import { NextPage } from "next";
import { CommonData } from "../types/CommonData";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { getCommonData } from "../helpers/common-data";

import { getAnnouncements } from "../helpers/getAnnouncements";
import { Announcement } from "../types/Announcement";
import { Search } from "../components/Search";
import { Wrapper } from "../components/Wrapper";
import { css } from "styled-components";
import { Spacing } from "../helpers/layout";
import { SEOTags } from "../components/SEOTags";
import { getFrontendUrl } from "../helpers/utils";
import { getRichSnippet } from "../helpers/rich-snippets/static";
import PreviewImage from "../static/images/preview-search.png";

export const PageSearch: NextPage<{
  commonData: CommonData;
  announcements: Announcement[];
}> = (props) => {
  const data = {
    title: "Search",
    keywords: "custom, search, palette, subject, orientation",
    description:
      "Search artworks by energy, orientation, tone, palette, location, and more.",
    url: getFrontendUrl(`/search`),
    about:
      "A customized search tool to help find a limited edition fine art print by Drew Doggett",
    image: PreviewImage,
  };

  return (
    <>
      <SEOTags
        title={data.title}
        keywords={data.keywords}
        description={data.description}
        url={data.url}
        image={data.image}
        richSnippets={getRichSnippet({
          name: data.title,
          slug: "search",
          keywords: data.keywords,
          description: data.description,
          about: data.about,
        })}
      />
      <Header announcements={props.announcements} />
      <div
        css={css`
          margin-top: ${Spacing.xl};
        `}
      >
        <Wrapper>
          <Search background="white" urlFilters isSticky skipPairings />
        </Wrapper>
      </div>
      <Footer />
    </>
  );
};

PageSearch.getInitialProps = async ({ req }) => {
  const commonData = await getCommonData(req);
  const announcements = await getAnnouncements("SHOP");

  return {
    commonData: commonData,
    announcements,
  };
};

export default PageSearch;
